import React from 'react';
import { DoctorsList } from './DoctorsList';
import { MedcentersList } from './MedcentersList';
import { SkillsList } from './SkillsList';
import type { SearchedDoctors } from '@/entities/doctor/model/types';
import type { SearchedMedcenters } from '@/entities/medcenter/model/types';
import type { Skill } from '@/entities/skill/model/types';
interface Props {
  skills: Skill[];
  doctors: SearchedDoctors[];
  medcenters: SearchedMedcenters[];
  cityAlias: string;
  setLoadNewPage: (value: boolean) => void;
}
export const SearchContent: React.FC<Props> = ({
  skills,
  doctors,
  medcenters,
  cityAlias,
  setLoadNewPage
}) => {
  return <>
      <SkillsList skills={skills} cityAlias={cityAlias} setLoadNewPage={setLoadNewPage} data-sentry-element="SkillsList" data-sentry-source-file="SearchContent.tsx" />

      <DoctorsList doctors={doctors} cityAlias={cityAlias} setLoadNewPage={setLoadNewPage} data-sentry-element="DoctorsList" data-sentry-source-file="SearchContent.tsx" />

      <MedcentersList medcenters={medcenters} cityAlias={cityAlias} setLoadNewPage={setLoadNewPage} data-sentry-element="MedcentersList" data-sentry-source-file="SearchContent.tsx" />
    </>;
};